import FetchStatusRepository   from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository        from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage             from "../../../../domain/fundamentals/pagination/CurrentPage";
import MailGroup               from "../../../../domain/mail/group/MailGroup";
import MailGroupRepository     from "../../../../domain/mail/group/MailGroupRepository";
import FetchStatusDataSource   from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailGroupDataSource     from "../../../../infrastructure/datasource/mail/group/MailGroupDataSource";
import NotifyDataSource        from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import SetValidateErrorMessage from "../../error/SetValidateErrorMessage";
import GetMailGroups           from "./GetMailGroups";

class RegisterMailGroup {
  private readonly mailGroupRepository: MailGroupRepository = new MailGroupDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly setValidateErrorMessage: SetValidateErrorMessage = new SetValidateErrorMessage(this.dispatch);
  private readonly getMailGroups: GetMailGroups = new GetMailGroups(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(mailGroup: MailGroup, callback: (value: boolean) => void) {
    this.fetchStatusRepository.start();
    try {
      await this.mailGroupRepository.register(mailGroup);
      await this.getMailGroups.execute(new CurrentPage());
      callback(false);
      this.notifyRepository.saveSuccess();
    } catch (e) {
      this.setValidateErrorMessage.execute(e);
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default RegisterMailGroup;
